import { useState } from 'react';
import { REQUEST_ACCESS_EMAIL } from './constants';

// Lead-capture logic for the "Request access" form.
// No backend: composes a prefilled mailto to REQUEST_ACCESS_EMAIL.
// Validates client-side, then hands off to the user's mail client.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function useRequestAccess() {
  const [form, setForm] = useState({ name: '', email: '', interest: '' });
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);

  const update = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
    if (error) setError('');
  };

  const submit = (e) => {
    e.preventDefault();
    const name = form.name.trim();
    const email = form.email.trim();
    if (!name) return setError('Please tell us your name.');
    if (!EMAIL_RE.test(email)) return setError('Please enter a valid email address.');

    const subject = `nroute access request — ${name}`;
    const lines = [
      `Name: ${name}`,
      `Email: ${email}`,
      form.interest.trim() ? `Interested in: ${form.interest.trim()}` : null,
      '',
      'Requesting early access to nroute.',
    ].filter(Boolean);

    const href = `mailto:${REQUEST_ACCESS_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(lines.join('\n'))}`;
    window.location.href = href;
    setSent(true);
  };

  return { form, error, sent, update, submit };
}
